import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { BtnsForTabsMenuType } from '@/types';
import { markRaw, onMounted, ref, Ref } from 'vue';
import { MortgageWidget, ServicesAndChecksWidget } from '@/components';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Services',
  setup(__props) {

const componentBtns: BtnsForTabsMenuType[] = [
  {
    id: 'checks',
    title: 'Сервисы и проверки',
    component: markRaw(ServicesAndChecksWidget),
  },
  { id: 'mortgage', title: 'Ипотечный калькулятор', component: markRaw(MortgageWidget) },
];

const getActiveComponent = (btnId: string | number) => {
  return componentBtns.find(el => el.id === btnId)?.component;
};

const activeComponentBtnId: Ref<undefined | number | string> = ref(undefined);

const router = useRouter();
const changeActiveBtn = (btnId: number | string) => {
  activeComponentBtnId.value = btnId;
  router.push({ query: { menuItem: btnId } });
};

onMounted(() => {
  const activeBtnId = useRoute().query.menuItem;

  if (activeBtnId && !!componentBtns.find(el => el.id === activeBtnId)) {
    changeActiveBtn(`${activeBtnId}`);
  } else {
    changeActiveBtn(componentBtns[0].id);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_menu_with_tabs = _resolveComponent("base-menu-with-tabs")!

  return (_openBlock(), _createBlock(_component_base_menu_with_tabs, {
    activeComponent: activeComponentBtnId.value,
    componentBtns: componentBtns,
    bgColor: "#fff",
    withRadius: "",
    onChangeActiveBtn: _cache[0] || (_cache[0] = ($event: any) => (changeActiveBtn($event)))
  }, {
    content: _withCtx((contentProps) => [
      (getActiveComponent(contentProps.data))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([{ services__mortgage: contentProps.data === 'mortgage' }, "menuWithTabsContent"])
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(getActiveComponent(contentProps.data)), {
              key: contentProps.data
            }))
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["activeComponent"]))
}
}

})